import { Injectable } from '@angular/core';

@Injectable()
export class GetFileSizeStringService {

  constructor() { }
  // Lets consider/discuss making FileSizeString and FileType a separate service that gets called.
  getReadableFileSizeString(fileSizeInBytes) {
    let i = -1;
    let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);
    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/getFileSize/get-file-size-string.service.ts